import { useCallback, useContext } from 'react'

import { GlobalStoreContext } from '~/contexts/GlobalStoreContext'
import { GlobalStoreProps } from '~/contexts/GlobalStoreReducer'
import type { FormTypes } from '~/data/forms/shared/interfaces/Form'
import { useFeatureFlag } from '~/hooks/useFeatureFlag'

import type { TradingFloorItemProps } from './TradingFloorList'

const useHooks = () => {
  const { stateDispatch } = useContext(GlobalStoreContext)
  const { getModalDialogFlag } = useFeatureFlag()
  const modalDialogFlag = getModalDialogFlag()

  const openForm = useCallback(
    (formType: FormTypes, item: TradingFloorItemProps) => {
      stateDispatch({
        type: GlobalStoreProps.UPDATE_MODAL_STATE,
        payload: {
          isOpen: true,
          content: formType,
          isDrawer: modalDialogFlag !== 'control',
          props: {
            isReducedWidth: true,
            artworkId: item.artworkId,
            heroProps: {
              artist: {
                name: item.artist,
                id: item.artistId,
              },
              image: item.image,
              title: item.title,
            },
          },
        },
      })
    },
    []
  )

  return {
    openForm,
  }
}

export default useHooks
